// Vendors
import $ from 'jquery';
import { AJAX_URL } from './config';

$(document).on('click', 'button.plus, button.minus', function () {
  // Get current quantity values
  const qty = $(this).parent().find('.qty');
  const val = parseFloat(qty.val());
  const max = parseFloat(qty.attr('max'));
  const min = parseFloat(qty.attr('min'));
  const step = parseFloat(qty.attr('step'));

  // Change the value if plus or minus
  if ($(this).is('.plus')) {
    if (max && max <= val) {
      qty.val(max);
      qty.trigger('change');
    } else {
      qty.val(val + step);
      qty.trigger('change');
    }
  } else {
    if (min && min >= val) {
      qty.val(min);
    } else if (val > 1) {
      qty.val(val - step);
      qty.trigger('change');
    }
  }
});

$('.woocommerce').on('change', 'input.qty', function () {
  $("[name='update_cart']").prop('disabled', false);
  $("[name='update_cart']").trigger('click');
});
